module.exports = __webpack_public_path__ + "static/media/icon_location.d2889408.svg";